import PropTypes from "prop-types";
import React from "react";
import { getCommonTranslation } from "../../utils/TranslationHelper";
import Flux from "../../flux/Flux";
import FeedPostCommentMenuDelete from "./FeedPostCommentMenuDelete";
import FeedPostCommentMenuReport from "./FeedPostCommentMenuReport";

const TYPES = {
    DELETE:   'delete',
    DELETED:  'deleted',
    REPORT:   'report',
    REPORTED: 'reported',
};

class FeedPostCommentMenu extends React.PureComponent {
	constructor(props) {
		super(props);
		this.state = {
            showMenu: false,
            type:      '',
		};

        this.onShow   = this.onShow.bind(this);
        this.onClose  = this.onClose.bind(this);
        this.getBadge = this.getBadge.bind(this);
        this.setType  = this.setType.bind(this);
        this.getModal = this.getModal.bind(this);
	}

    getMenu() {
        let content = '';
        
        if (this.props.comment.user && (parseInt(this.props.comment.user.id) === Flux.Guest.getId())) {
            content = <div className="feed__comment-tour__modal-text feed__comment-tour__modal-text--icon feed__comment-tour__modal-text--red" onClick={() => this.setType(TYPES.DELETE)}>
                <i className="icon -icon-trash-empty"></i>
                {getCommonTranslation('delete')}
            </div>;
        } else {
           content = <div className="feed__comment-tour__modal-text feed__comment-tour__modal-text--icon" onClick={() => this.setType(TYPES.REPORT)}>
                <i className="icon -icon-round-warning-line"></i>
                {getCommonTranslation('report')}
            </div>;
        }

        return this.getModal({
            title: getCommonTranslation('comment'),
            content,
        });
    }

    setType(type) {
        this.setState({type});
    }

    onShow() {
        this.setState({showMenu: true, type: ''});
    }

    onClose() {
        this.setState({showMenu: false, type: ''});
    }

    getModal({title = '', content = '', button = null, full = false}) {
        const close = () => {
            this.onClose();
        };
 
        return <div className={"feed__comment-tour__modal-wrapper" + (full ? " feed__comment-tour__modal-wrapper--fixed" : "")} onClick={close}>
            <div className="feed__comment-tour__modal" onClick={ (e) => {e.stopPropagation();}}>
                    <i className="icon -icon-close-line feed__comment-tour__modal-close" onClick={close}></i>
                    {title   && <div className="feed__comment-tour__modal-title">{title}</div>}
                    {content && <div className="feed__comment-tour__modal-content">{content}</div>}
                    {button  && <div className="feed__comment-tour__modal-button">{button}</div>}
            </div>
        </div>;
    }

    getBadge({content}) {
        const timeOut = setTimeout(() => {
            clickFn();
         }, 1500);

         const clickFn = () => {
            this.onClose();
            this.updatePost();
            clearTimeout(timeOut);
         };

         return <div className={"feed__comment-tour__modal-wrapper feed__comment-tour__modal-wrapper--fixed"} onClick={clickFn}>
            <div className="feed__comment-tour__modal-badge">
                {content}
            </div>
         </div>;
    }

    getContent() {
        switch(this.state.type) {
            case TYPES.DELETE:
            case TYPES.DELETED:
                return <FeedPostCommentMenuDelete 
                        type={this.state.type}
                        types={TYPES}
                        commentId={this.props.comment.id}
                        setType={this.setType}
                        getBadge={this.getBadge}
                        getModal={this.getModal}
                        />;
            case TYPES.REPORT:
                return <FeedPostCommentMenuReport
                        type={this.state.type}
                        types={TYPES}
                        commentId={this.props.comment.id}
                        setType={this.setType}
                        getBadge={this.getBadge}
                        getModal={this.getModal}
                        />;
            default:
                return this.getMenu();
        }        
    }

    updatePost() {
        Flux.Feed.triggerUpdatePost(this.props.postId);
    }

    getMoreIcon() {
        return <div className="feed__comment-tour__icon" onClick={this.onShow}><span></span><span></span><span></span></div>;
    }

	render() {
        //currently only delete available
        if (this.props.comment.user && !(parseInt(this.props.comment.user.id) === Flux.Guest.getId())) {
            return null;
        }
        return <div className="feed__comment-tour">
            {this.getMoreIcon()}
            {this.state.showMenu && this.getContent()}
        </div>;
	}
}

FeedPostCommentMenu.propTypes = {
	comment: PropTypes.object.isRequired,
	postId:  PropTypes.string.isRequired,
};

export default FeedPostCommentMenu;
